import React, { forwardRef } from 'react';
import { useDateSegment } from '@react-aria/datepicker';
import cn from 'classnames';
import { useForwardedRef } from '../../hooks';
import styles from './styles.module.css';
export const DateSegment = forwardRef(function DateSegment({ segment, state }, ref) {
    const segmentRef = useForwardedRef(ref);
    const { segmentProps } = useDateSegment(segment, state, segmentRef);
    // важна именно такая верстка
    // https://github.com/adobe/react-spectrum/issues/3164
    return (React.createElement("div", { className: styles.segmentWrapper },
        React.createElement("div", { ...segmentProps, className: cn(styles.segment, {
                [styles.placeholder]: segment.isPlaceholder,
            }), ref: segmentRef }, segment.text)));
});
